module.exports = __webpack_public_path__ + "static/media/miaou3.88624ed5.mp3";